var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistorical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FDEFD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2174:3069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2512 9.10163C13.9277 8.8614 13.5148 8.69636 13.0887 8.63288C12.9594 7.86765 12.6158 7.21355 12.0867 6.72957C11.5264 6.21589 10.7854 5.93347 10 5.93347C9.30957 5.93347 8.67188 6.14988 8.15684 6.55945C7.76553 6.87101 7.46075 7.27781 7.27168 7.74089C6.68691 7.83074 6.15605 8.06667 5.76016 8.4157C5.26289 8.85417 5 9.43835 5 10.1053C5 10.7796 5.28301 11.3944 5.79668 11.8389C6.2873 12.2626 6.94785 12.496 7.65625 12.496H9.6875V9.50046L8.75 10.438L8.30801 9.99597L10 8.30417L11.692 9.99597L11.25 10.438L10.3125 9.50046V12.496H12.7344C13.3465 12.496 13.9045 12.3241 14.3057 12.0122C14.76 11.6587 15 11.1528 15 10.5507C15 9.96589 14.741 9.46453 14.2512 9.10163Z",
    fill: "#F5C006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 12.4957H9.68747V14.0662H10.3125V12.4957Z",
    fill: "#F5C006"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2174:3069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorical);
export default __webpack_public_path__ + "static/media/historical.cff99f9e46713162fa612f11fcb9884e.svg";
export { ForwardRef as ReactComponent };